module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.b2d0b312.webp";